import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel
} from 'react-accessible-accordion';
import Metric from '../../../Shared/Metrics/Metric';
import SpeedMetric from '../../../Shared/Metrics/SpeedMetric';
import React, { useEffect, useState } from 'react';
import {
  fixDecimals,
  toPercentage,
  isNonNegativeNumber
} from '../../../../helpers/helpers';
import './Metrics.scss';
import { Metrics, PerformanceRoutes } from '../types';
import CustomTableFilter from 'components/Shared/Filters/CustomTableFilter';
import { useRouter } from 'helpers/customHooks';
import { EXPANDED, FILTER_KEYS, FUTURE_PRACTICE, PERFORMANCE, VIEW, BY_PERIOD, CONDENSED, VIEW_LIVE } from 'config/constants';
import { useDataEventsState, useFiltersState } from 'store/hooks';

export default ({ liveData, shownHighlights, setShownHighlights, live, customLoad, customLoadLive } : Metrics) => {
  const [showFilter, setShowFilter] = useState(-1);
  const close = () => setShowFilter(-1);
  const {
    params,
    forcedScopeForFilter: scopeForFilter
  } = useRouter<PerformanceRoutes>();
  const { [FILTER_KEYS.VIEW]: viewData = VIEW.types[0], 
          [FILTER_KEYS.VIEW_LIVE]: viewLive = VIEW_LIVE.types[0]} = useFiltersState(scopeForFilter, FILTER_KEYS.VIEW, FILTER_KEYS.VIEW_LIVE);
  const { tab, subTab, view } = params;
  const { dataEvent: data } = useDataEventsState();
  const isMobile = window.matchMedia("only screen and (max-width: 900px)").matches;
  useEffect(() => {
    setShownHighlights(true);
  }, []);
  return (
    <>
    <div
      className={'acordion a-01' + (!shownHighlights ? ' collapsed' : '')}
      style={{ borderBottom: '1px solid #636B73', height: shownHighlights ? 'auto' : '28px' }}
    >
      <div className={'accordion-title ' + (shownHighlights ? 'hide' : '')}>open summary</div>
      <Accordion allowZeroExpanded>
        <AccordionItem>
          <AccordionItemHeading
            data-toggle="collapse" data-target="accordion__panel-0"
            onClick={() => setShownHighlights(!shownHighlights)} style={{ borderBottom: 'none' }}
          >
            <AccordionItemButton className={'accordion__button ' + (shownHighlights ? 'accordion__button_down' : '')}>
            </AccordionItemButton>
          </AccordionItemHeading>
          {shownHighlights && <AccordionItemPanel
            // style={{display: shownHighlights ? null : 'none !important'}}
            // className={shownHighlights ? 'accordion__heading ' : ' hide'}
            style={{ borderBottom: 'none' }}
          >
            <Metric
              label="AVG. TTL. DIST. (YDS)"
              current={liveData.highlights.aveDistYards ? liveData.highlights.aveDistYards : 0}
              target={liveData.highlights.hasOwnProperty('aveDistYards_%') && isNonNegativeNumber(liveData.highlights['aveDistYards_%']) ?
                toPercentage(liveData.highlights['aveDistYards_%']) : '-'}
            />
            <Metric
              label="AVG. H.E. DIST. (YDS)"
              current={liveData.highlights.aveHardEffortDist}
              target={liveData.highlights.hasOwnProperty('aveHardEffortDist_%') && isNonNegativeNumber(liveData.highlights['aveHardEffortDist_%']) ?
                toPercentage(liveData.highlights['aveHardEffortDist_%']) : '-'}
            />
            <Metric
              label="AVG. YARDS/MIN"
              current={liveData.highlights.aveYPM ? liveData.highlights.aveYPM : 0}
              target={liveData.highlights.hasOwnProperty('aveYPM_%') && isNonNegativeNumber(liveData.highlights['aveYPM_%']) ?
                toPercentage(liveData.highlights['aveYPM_%']) : '-'}
            />
            <SpeedMetric
              label="AVG. MAX SPEED (MPH)"
              current={fixDecimals(liveData.highlights.aveMaxSpeedMPH ? liveData.highlights.aveMaxSpeedMPH : 0, 1)}
              target={liveData.highlights.hasOwnProperty('aveMaxSpeedMPH_%') && isNonNegativeNumber(liveData.highlights['aveMaxSpeedMPH_%']) ?
                liveData.highlights['aveMaxSpeedMPH_%'] : '-'}
              max={23}
              height="30"
              width="115"
              left="50"
              top="-5"
            />
            <SpeedMetric
              label="AVG. MAX SUST. SPEED (MPH)"
              current={fixDecimals(liveData.highlights.aveMaxSustainedSpeedMPH ? liveData.highlights.aveMaxSustainedSpeedMPH : 0, 1)}
              target={liveData.highlights.hasOwnProperty('aveMaxSustainedSpeedMPH_%') && isNonNegativeNumber(liveData.highlights['aveMaxSustainedSpeedMPH_%']) ?
                liveData.highlights['aveMaxSustainedSpeedMPH_%'] : '-'}
              max={23}
              height="30"
              width="115"
              left="50"
              top="-5"
            />
            <Metric
              label="AVG. SPRINT COUNT"
              current={liveData.highlights.aveSprintCount ? liveData.highlights.aveSprintCount : 0}
              target={liveData.highlights.hasOwnProperty('aveSprintCount_%') && isNonNegativeNumber(liveData.highlights['aveSprintCount_%']) ?
                toPercentage(liveData.highlights['aveSprintCount_%']) : '-'}
            />
            <Metric
              label="AVG. MAX SPRINT COUNT"
              current={liveData.highlights.aveMaxSprintCount ? liveData.highlights.aveMaxSprintCount : 0}
              target={liveData.highlights.hasOwnProperty('aveMaxSprintCount_%') && isNonNegativeNumber(liveData.highlights['aveMaxSprintCount_%']) ?
                toPercentage(liveData.highlights['aveMaxSprintCount_%']) : '-'}
            />
            <Metric
              label="AVG. TTL. ACCELS"
              current={liveData.highlights.accelsAve ? liveData.highlights.accelsAve : 0}
              target={liveData.highlights.hasOwnProperty('accelsAve_%') && isNonNegativeNumber(liveData.highlights['accelsAve_%']) ?
                toPercentage(liveData.highlights['accelsAve_%']) : '-'}
            />
            <Metric
              label="AVG. TTL. DECELS"
              current={liveData.highlights.deccelsAve ? liveData.highlights.deccelsAve : 0}
              target={liveData.highlights.hasOwnProperty('deccelsAve_%') && isNonNegativeNumber(liveData.highlights['deccelsAve_%']) ?
                toPercentage(liveData.highlights['deccelsAve_%']) : '-'}
            />
            {!live &&
            //<div className='unavailable-metric'> <label>Unavailable while practice is live</label></div>
            <Metric
              label="AVG. EXERT. INDEX"
              current={liveData.highlights.exIndexAve ? liveData.highlights.exIndexAve : 0}
              target={liveData.highlights.hasOwnProperty('exIndexAve_%') && isNonNegativeNumber(liveData.highlights['exIndexAve_%']) ?
                toPercentage(liveData.highlights['exIndexAve_%']) : '-'}
            />}
          </AccordionItemPanel>}
        </AccordionItem>
      </Accordion>
    </div>
    { data.meta.type !== FUTURE_PRACTICE && tab === PERFORMANCE && (subTab === EXPANDED || (subTab === BY_PERIOD && view === EXPANDED)) && !isMobile && viewData.value === VIEW.types[10].value &&(
      <CustomTableFilter
     show={showFilter === 11}
     close={close}
     open={()=> setShowFilter(11)}
     forceScope={scopeForFilter}
     customLoad={customLoad}
     setShowFilter={showFilter}
     /> 
    )
    }
    { data.meta.type !== FUTURE_PRACTICE && tab === PERFORMANCE && (subTab === CONDENSED || (view === CONDENSED)) && !isMobile && viewLive.value === VIEW_LIVE.types[1].value &&(
      <CustomTableFilter
     show={showFilter === 12}
     close={close}
     open={()=> setShowFilter(12)}
     forceScope={scopeForFilter}
     customLoad={customLoadLive}
     setShowFilter={showFilter}
     liveTab={true}
     /> 
    )
    }
     </>
  );
};
